import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/services/api/client";

export function useWatchlistsQuery() {
  return useQuery({
    queryKey: ["watchlists"],
    queryFn: () => apiClient.listWatchlists(),
    staleTime: 30_000,
  });
}

export function useWatchlistItemsQuery(watchlistId: number | null) {
  return useWatchlistItemsSortedQuery(watchlistId, {});
}

export function useWatchlistItemsSortedQuery(
  watchlistId: number | null,
  options: { sortBy?: string; sortDir?: "asc" | "desc"; limit?: number; offset?: number },
) {
  const { sortBy, sortDir, limit, offset } = options;
  return useQuery({
    queryKey: ["watchlists", watchlistId, "items", sortBy || "auto", sortDir || "auto", limit || 0, offset || 0],
    queryFn: () => apiClient.listWatchlistItems(watchlistId as number, { sortBy, sortDir, limit, offset }),
    enabled: watchlistId !== null,
    staleTime: 10_000,
    refetchInterval: 15_000,
  });
}

export function useTaskSummaryQuery() {
  return useQuery({
    queryKey: ["tasks", "summary"],
    queryFn: () => apiClient.getTaskSummary(),
    refetchInterval: 15_000,
  });
}
